var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateNewProjectFromScratch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 128,
    viewBox: "0 0 137 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "zcp177hcxa",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 137,
    height: 128
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 135,
    height: 127,
    rx: 4.5,
    fill: "#F9F9FB",
    stroke: "#D6DAE4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#zcp177hcxa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#22283C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M-17.239 85h171.478v155H-17.239zM33.022 46h70.957v26H33.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.045 54h-2.878v3.65H41.57v2.92h3.597v3.65h2.878v-3.65h3.598v-2.92h-3.598V54z",
    fill: "#22283C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECEEF5",
    d: "M58.645 57h33.507v4H58.645zM11.341 97h7.884v4h-7.884zM24.152 97h79.826v4H24.152zM124.674 97h38.435v4h-38.435zM11.341 107h7.884v4h-7.884zM24.152 107h59.13v4h-59.13zM124.674 107h38.435v4h-38.435z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateNewProjectFromScratch);
export default __webpack_public_path__ + "static/media/CreateNewProjectFromScratch.6f9d453413df7940d462c0f63a786a48.svg";
export { ForwardRef as ReactComponent };